import { render } from "./IconRefresh.vue?vue&type=template&id=716f357c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconRefresh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "716f357c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('716f357c', __exports__)) {
    api.reload('716f357c', __exports__)
  }
  
  module.hot.accept("./IconRefresh.vue?vue&type=template&id=716f357c", () => {
    api.rerender('716f357c', render)
  })

}


export default __exports__